import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-home-library-icon',
  templateUrl: './home-library.component.html'
})
export class HomeLibraryComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
